module.exports = __webpack_public_path__ + "img/DE01102.399ba504.png";